export const TID = {
  // Landing
  landingRegister: "landing-register-btn",
  landingLogin: "landing-login-btn",
  emergencyBanner: "emergency-banner",
  hotelName: "landing-hotel-name",
  roomNumber: "landing-room-number",
  // Auth
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  toRegister: "auth-to-register",
  toLogin: "auth-to-login",
  logoutBtn: "logout-btn",
  // Triage
  triageInput: "triage-input",
  triageSend: "triage-send",
  triageSkip: "triage-skip",
  triageContinue: "triage-continue",
  // Doctors
  doctorCard: "doctor-card",
  connectNow: "connect-now-btn",
  scheduleBtn: "schedule-btn",
  // Booking
  bookDate: "book-date",
  bookTime: "book-time",
  bookConfirm: "book-confirm",
  // Consultation
  endCall: "end-call-btn",
  micBtn: "mic-toggle-btn",
  camBtn: "cam-toggle-btn",
  // Doctor
  noteS: "note-subjective",
  noteO: "note-objective",
  noteA: "note-assessment",
  noteP: "note-plan",
  saveNotes: "save-notes-btn",
  // Staff
  staffBookingRow: "staff-booking-row",
  // QR admin
  qrHotelSelect: "qr-hotel-select",
  qrRoomInput: "qr-room-input",
  qrGenerate: "qr-generate-btn",
  qrList: "qr-list",
};
